module.exports = __webpack_public_path__ + "img/news30-1.dc5b8ae6.png";